export default () => {
  return store => {
    store.watch(
      state => state.toolbar.showLegacy,
      () => {
        KR.toolbarReady = false

        store.commit('UPDATE', { toolbar: { reload: false } })
        store.dispatch('loadToolbar')
      }
    )
  }
}
